import type { StateKey } from '@angular/core';
import { InjectionToken, makeStateKey } from '@angular/core';

export const APP_VERSION = new InjectionToken<string>('App version');
export const APP_VERSION_KEY: StateKey<string> = makeStateKey('appVersion');
